import React from 'react';
import classNames from 'classnames';

const ReceiptsListSkeletonLoader: React.FC = () => {
  return (
    <div className="animate-pulse">
      <div className="flex justify-between items-center py-2 px-4 rounded-t-xl">
        {[...Array(4)].map((_, index) => (
          <div
            key={`receipts-list-head-${index}`}
            className="w-1/4 h-8 flex items-end justify-start"
          >
            <div className="w-12 h-6 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
      {[...Array(3)].map((_, index) => (
        <div
          key={`receipts-skeleton-item-${index}`}
          className={classNames(
            'flex justify-between space-x-4 items-center py-5 px-4 border-t border-gray-100',
            {
              'bg-gray-50 bg-opacity-90 hover:bg-opacity-100': index % 2 !== 0,
            },
          )}
        >
          <div className="w-1/4 h-8 bg-gray-200 rounded"></div>
          <div className="w-1/4 h-8 bg-gray-200 rounded"></div>
          <div className="w-1/4 h-8 bg-gray-200 rounded"></div>
          <div className="w-1/4 h-8 bg-gray-200 rounded"></div>
        </div>
      ))}
    </div>
  );
};

export default ReceiptsListSkeletonLoader;
